/**
 * Permission hooks — the non-component half of story 0.4.
 *
 * Split from `PermissionProvider.tsx` because a file exporting both a component
 * and a hook breaks React Fast Refresh, and this repo holds lint at zero warnings.
 *
 * 🔒 **CLIENT-SIDE GATING IS UX, NEVER A SECURITY BOUNDARY (BR-17).** A hidden
 * button spares the user a refusal they could not have predicted. It protects
 * nothing. Every screen must remain correct if this whole layer were deleted.
 */
import { createContext, useContext } from 'react'

import { acessoDe, SEM_ACESSO, type Acesso, type MapaPermissoes } from '@/permissions/resolver'

export const ContextoDePermissoes = createContext<MapaPermissoes | null>(null)

/**
 * The effective access for one tela/aba key.
 *
 * Returns `SEM_ACESSO` outside a provider rather than throwing: a permission
 * question asked too early should answer "no", which is the safe direction. That
 * differs deliberately from `useClienteAtual()`, where a missing tenant is a
 * routing bug and must be loud.
 */
export function usePermission(chave: string): Acesso {
  const mapa = useContext(ContextoDePermissoes)
  if (!mapa) return SEM_ACESSO
  return acessoDe(mapa, chave)
}

/** The whole map — for the sidebar, which asks about every module at once. */
export function usePermissoes(): MapaPermissoes {
  return useContext(ContextoDePermissoes) ?? new Map()
}
